import Sorting from "../layout-settings/sorting";
import Roles from "../layout-settings/roles";
import Users from "../layout-settings/users";
import HideOnScreen from "../layout-settings/hide-on-screen";
var LayoutSettings = /** @class */ (function () {
    function LayoutSettings(el, form) {
        this.element = el;
        this.form = form;
        this.settings = {};
        this.init();
    }
    LayoutSettings.prototype.addSetting = function (name, setting) {
        this.settings[name] = setting;
    };
    LayoutSettings.prototype.init = function () {
        this.addSetting('sorting', new Sorting(this.form));
        this.addSetting('roles', new Roles(this.element));
        this.addSetting('users', new Users(this.element));
        var hideOnScreen = document.getElementById('hide-on-screen');
        if (hideOnScreen) {
            this.addSetting('hideonscreen', new HideOnScreen(hideOnScreen));
        }
    };
    return LayoutSettings;
}());
export default LayoutSettings;
